import { POSVariantGroup, UnavailableItemsContract } from 'models'
import { createContext, useContext } from 'react'
import {
    ComboViewModel,
    ModifierOptionLookup,
    PriceListData,
    ItemMap,
    ISelectItemInCart,
    EntityModifierViewModel,
    MenuViewModel,
    EntityModifiersMap,
} from 'store/models/sellModels'
import { TOldSaleData } from 'views/Sale/hooks/useSaleSelectReducer/useSaleSelectReducer'

export interface ICartContext {
    menus: MenuViewModel[]
    comboChoicesMap: Record<string, ComboViewModel[]>
    priceListData: PriceListData
    unavailableProducts: UnavailableItemsContract
    itemsMap: ItemMap
    modifierOptionsMap: ModifierOptionLookup
    removedData: TOldSaleData
    modifierList: EntityModifierViewModel[]
    variantGroupsMap: Record<string, POSVariantGroup>
    selectedItemInCart?: ISelectItemInCart | undefined
    /** on select discount or comp in cart */
    onSelectDiscountOrComp?: (item: ISelectItemInCart) => void
    strictTimeAvailability: boolean
    entityModifiersMap: EntityModifiersMap
}

const CartContext = createContext<ICartContext>({} as ICartContext)

export const useCartContext = () => useContext(CartContext)

export default CartContext
